export const DATA_DEM = "data/dem"
export const DATA_LAMPS = "data/lamps"
export const DATA_WATERSHED = "data/watershed"
